import React, { useCallback } from 'react'
import dayjs from 'dayjs'
import MediaList from 'components/partials/MediaList'
import MediaContent from 'components/partials/MediaContent'
import IconArrowRight from 'components/partials/IconArrowRight'
import Description from 'components/partials/Description'
import Breadcrumb from 'components/Breadcrumb'
import { Link } from 'components/Link'
import Label from 'components/Label'
import MetaContainer from 'components/partials/MetaContainer'
import ViewModeContext from 'contexts/ViewModeContext'
import useClickLogger from 'api/ClickLogger'

function ResearchStoryTemplate({ ...doc }) {
  return (
    <ViewModeContext.Consumer>
      {context => context.isTable ? (
        <ResearchStoryTable {...doc} />
      ) : (
        <ResearchStoryTeaser {...doc} />
      )}
    </ViewModeContext.Consumer>
  )
}

function ResearchStoryTable({
  title,
  preamble_cutoff,
  url,
  _click,
  research_areas,
  __research_type_short__,
  published,
}) {
  const { trackResultClick } = useClickLogger(_click, url);
  return (
    <tr onClick={trackResultClick} style={{ cursor: 'pointer' }}>
      <td>
        <div className='media'>
          <MediaContent>
            <Link href={url}>
              <span dangerouslySetInnerHTML={{ __html: title }} />
              <IconArrowRight />
            </Link>
            <Description text={preamble_cutoff} modifierClasses="u-mt-25" />
          </MediaContent>
        </div>
      </td>
      <td>
        <Description text={__research_type_short__} />
      </td>
      <td>
        <Description text={published && dayjs(published).format('L')} />
      </td>
      <td>
        <Description text={[].concat(research_areas).join(', ')} />
      </td>
    </tr>
  )
}

function ResearchStoryTeaser({
  title,
  preamble_cutoff,
  url,
  _click,
  research_areas,
  published,
  __breadcrumb__,
}) {
  const { trackResultClick } = useClickLogger(_click, url);
  return (
    <MediaList onClick={trackResultClick}>
      <MediaContent>
        <Link href={url}>
          <span dangerouslySetInnerHTML={{ __html: title }} />
          <IconArrowRight />
        </Link>
        <MetaContainer>
          <Label
            modifierClasses='u-font-weight-700 u-mt-25 u-mr-100'
            text={published && dayjs(published).format('L')}
          />
          <Label
            modifierClasses='u-font-weight-700 u-mt-25 u-mr-100'
            text={[].concat(research_areas).join(', ')}
          />
        </MetaContainer>
        <Description text={preamble_cutoff} modifierClasses="u-mt-25" />
        <Breadcrumb links={__breadcrumb__} modifierClasses="u-mt-50" disabled />
      </MediaContent>
    </MediaList>
  )
}
export default ResearchStoryTemplate
